
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/support",
      function () {
        return require("private-next-pages/actuary/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/support"])
      });
    }
  